import type { FC } from 'react';

import { Spinner } from '@shared/components/ui';
import { cn } from '@shared/utils';

export const LoadingPageSpinner: FC<{ message?: string }> = ({ message = 'Loading...' }) => {
  return (
    <div
      className={cn('flex flex-col items-center justify-center p-8 gap-3', 'flex-1 w-full')}
      data-testid="page-loading-container"
    >
      <Spinner className="text-primary" data-testid="container-loading-spinner" />
      <span className="text-sm text-muted-foreground font-medium" data-testid="container-loading-text">
        {message}
      </span>
    </div>
  );
};
